import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { TimerIcon } from 'lucide-react';
export function FloatingOffer() {
  const [isVisible, setIsVisible] = useState(false);
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  // Show the offer when the bonuses section becomes visible
  useEffect(() => {
    const showOfferAtBonusesSection = () => {
      const bonusesSection = document.getElementById('bonos-de-regalo');
      if (!bonusesSection) return;
      const {
        top
      } = bonusesSection.getBoundingClientRect();
      const bonusesAreVisible = top <= window.innerHeight * 0.7;
      if (bonusesAreVisible) {
        setIsVisible(true);
        window.removeEventListener('scroll', showOfferAtBonusesSection);
      }
    };
    window.addEventListener('scroll', showOfferAtBonusesSection, {
      passive: true
    });
    showOfferAtBonusesSection();
    return () => window.removeEventListener('scroll', showOfferAtBonusesSection);
  }, []);
  // Countdown timer effect
  useEffect(() => {
    if (!isVisible) return;
    const interval = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(interval);
  }, [isVisible]);
  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };
  const UPSELL_CHECKOUT_URL = 'https://4sfaxb-5b.myshopify.com/cart/53494883942707:1?channel=buy_button';
  return <>
      {/* old_string > */}
      <old_string data-id="element-87">
        {' '}
        <img src="https://cdn.magicpatterns.com/uploads/xntdg5Nr6p8J4aPupFKMFj/Diseno_sin_titulo_(1).png" alt="Dominando Shopify" className="w-full h-full object-cover" data-id="element-88" />
      </old_string>

      {/* <new_string> */}
      <img src="https://cdn.magicpatterns.com/uploads/3GQCD9ea87ZTu2CofcAQK5/mockup_4.png" alt="Dominando Shopify" className="w-full h-full object-cover" data-id="element-89" />
      <AnimatePresence data-id="element-90">
        {isVisible && <motion.div initial={{
        y: 100,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 100,
        opacity: 0
      }} className="fixed bottom-4 left-4 right-4 z-50 max-w-md mx-auto" data-id="element-91">
            {/* Countdown Tag */}
            <div className="flex justify-center -mb-3 relative z-10" data-id="element-92">
              <div className="bg-red-600 text-white px-4 py-1 rounded-full text-xs font-black flex items-center gap-2 shadow-[0_0_15px_rgba(220,38,38,0.6)] animate-pulse" data-id="element-93">
                <TimerIcon className="w-3 h-3" data-id="element-94" />
                LA OFERTA TERMINA EN {formatTime(timeLeft)}
              </div>
            </div>

            {/* Main Card */}
            <div className="bg-[#0A0D16] border-2 border-[#FC9DFF] rounded-2xl p-4 shadow-[0_0_20px_rgba(252,157,255,0.3)] animate-neon-violet" data-id="element-95">
              <div className="flex items-center justify-between mb-3 px-2" data-id="element-96">
                <div className="flex items-center gap-3" data-id="element-97">
                  <div className="w-12 h-12 bg-[#121212] rounded-lg border border-[#FC9DFF]/30 flex items-center justify-center overflow-hidden" data-id="element-98">
                    <img src="https://cdn.magicpatterns.com/uploads/xntdg5Nr6p8J4aPupFKMFj/Diseno_sin_titulo_(1).png" alt="Dominando Shopify" className="w-full h-full object-cover" data-id="element-99" />
                  </div>
                  <div data-id="element-100">
                    <h4 className="text-white font-bold text-sm leading-tight" data-id="element-101">
                      Dominando Shopify
                    </h4>
                    <p className="text-[#FC9DFF] font-black text-lg" data-id="element-102">
                      $49.990 ARS
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex flex-col items-center w-full" data-id="element-103">
                <span className="text-[10px] font-bold uppercase tracking-widest text-green-400 mb-1 animate-pulse" data-id="element-104">
                  ⚡ Acceso Inmediato
                </span>
                <a href={UPSELL_CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="w-full bg-[#00FF94] hover:bg-[#00E082] text-black font-black py-3 rounded-xl flex items-center justify-center gap-2 transition-all transform hover:scale-[1.02] shadow-[0_0_20px_rgba(0,255,148,0.4)] animate-[neon-green-glow_2s_infinite]" data-id="element-105">
                  🔥 ACCEDER AHORA
                </a>
              </div>

              <p className="text-gray-400 text-[10px] text-center mt-2 font-medium" data-id="element-106">
                +500 alumnos cambiando su vida y viviendo de internet
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}